<template>
  <div class="text-xs-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      lazy
    >
      <template #activator="{ on }">
        <v-btn flat icon v-on="on">
          <v-icon>tune</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-layout wrap row pa-3>
          <v-flex v-if="!entityId" xs12 px-2>
            <v-autocomplete
              v-model="localFilters.entityId"
              :items="entityList"
              :label="
                $t('action.actions.select', { field: $tc('models.entity') })
              "
              :loading="$store.state.entities.loading"
              clearable
              no-filter
              chips
              :search-input.sync="searchEntity"
            >
              <template #selection="data">
                <v-chip
                  color="white"
                  :selected="data.selected"
                  class="chip--select-multi"
                >
                  <v-avatar>
                    <img :src="data.item.logo" />
                  </v-avatar>
                  {{ data.item.text }}
                </v-chip>
              </template>
              <template #item="data">
                <v-list-tile-avatar>
                  <img :src="data.item.logo" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.text" />
                </v-list-tile-content>
              </template>
              <!--          -->
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 px-2>
            <category-menu
              v-model="localFilters.categoryId"
              clearable
              :label="
                $t('action.actions.select', { field: $tc('models.category') })
              "
            />
          </v-flex>
          <v-flex xs12 md6 px-2>
            <v-checkbox
              v-model="localFilters.lineUpCompleted"
              :label="$t('fields.teams.lineUpCompleted')"
              color="primary"
              @change="onChangeLineUpCompleted"
            />
          </v-flex>
        </v-layout>

        <v-divider />
        <v-card-actions>
          <v-spacer />

          <v-btn
            color="primary"
            flat
            :loading="$store.state.teams.loading"
            @click="search"
          >
            {{ $t('action.buttons.search') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { debounce } from 'debounce'
import { mapState, mapActions, mapGetters } from 'vuex'
import CategoryMenu from '@/components/management/categories/CategoryMenu'
export default {
  name: 'TeamFilters',
  components: { CategoryMenu },
  props: {
    entityId: { type: String },
  },
  data: () => ({
    menu: false,
    searchEntity: '',
    entityList: [],
  }),
  watch: {
    searchEntity() {
      if (!this.filters.entityId) {
        this.debounceEntities()
      }
    },
  },
  mounted() {
    this.debounceEntities()
  },
  computed: {
    ...mapState({
      filters: (state) => state.teams.filters,
      roles: (state) => state.auth.roles,
    }),
    ...mapGetters({
      entitySelectList: 'entities/selectList',
    }),
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.setFilters(value)
      },
    },
  },
  methods: {
    ...mapActions({
      fetchTeams: 'teams/fetchList',
      setFilters: 'teams/setFilters',
    }),
    search() {
      this.debounceFetch('teams')
      this.menu = false
      this.$emit('search')
    },
    onChangeLineUpCompleted(val) {
      if (!val) this.localFilters.lineUpCompleted = undefined
    },
    debounceEntities: debounce(function () {
      let params = { set: false }
      if (this.searchEntity) {
        params.match = this.searchEntity
      }
      let ids = []
      let teamIds = []
      if (this.roles) {
        // console.log(this.roles)
        this.roles
          .filter(
            (role) =>
              role.roleId.type == 'coordinator' ||
              role.roleId.type == 'president'
          )
          .map((role) => role.objectId[0])
          .forEach((id) => ids.push(id))
        this.roles
          .filter((role) => role.roleId.type == 'trainer')
          .map((role) => role.objectId[0])
          .forEach((id) => teamIds.push(id))
      }
      if (ids.length) params._id = ids
      if (teamIds.length) params.teamId = teamIds
      this.$store
        .dispatch('entities/fetchSelectList', params)
        .then((result) => {
          this.entityList = result
        })
    }, 700),
  },
}
</script>
